import React from 'react'
import _ from 'lodash' // eslint-disable-line no-unused-vars
import  * as icons from 'constants/icons' // eslint-disable-line no-unused-vars
import { MuiThemeProvider } from '@material-ui/core/styles'
import firebase from 'providers/firebase'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { Provider } from 'react-redux'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import theme from './theme'
import { reduxFirebase as rfConfig } from './config'
import Root from './routes'
import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars

function App({ store }) {
  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <ReactReduxFirebaseProvider
          firebase={firebase}
          config={rfConfig}
          dispatch={store.dispatch} >
          <BrowserRouter>
            <Switch>
              <Route
                render={props => <Root store={store} />}
              />
            </Switch>
          </BrowserRouter>
        </ReactReduxFirebaseProvider>
      </Provider>
    </MuiThemeProvider>
  )
}

App.propTypes = {
  store: PropTypes.object.isRequired
}

export default App
